import { useState, useEffect } from 'react'
import './Blog.scss'

import { urlFor, client } from '../../client'

const Blog = () => {
  const [currentSlide, setCurrentSlide] = useState(0)
  const [data, setData] = useState([])

  useEffect(() => {
    const query = '*[_type == "blogs"]'

    client.fetch(query).then((data) => {
      setData(data)
    })
  }, [])
  

  const handleClick = (way) => {
    way === 'left'
      ? setCurrentSlide(currentSlide > 0 ? currentSlide - 1 : 2)
      : setCurrentSlide(currentSlide < data.length - 1 ? currentSlide + 1 : 0)
  }

  return (
    <div className='blog' id='blog'>
      <h1>Recent Updates</h1>
      <div
        className='slider'
        style={{ transform: `translateX(-${currentSlide * 100}vw)` }}
      >
        {data.map((d) => (
          <div className='container'>
            <div className='item'>
              <div className='left'>
                <div className='imgContainer'>
                  {d.img !== '' && <img src={urlFor(d.img)} alt={d.title} />}
                </div>
              </div>
              <div className='right'>
                <h2>{d.title}</h2>
                <p>{d.desc}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <img
        src='assets/arrow.png'
        className='arrow left'
        alt=''
        onClick={() => handleClick('left')}
      />
      <img
        src='assets/arrow.png'
        className='arrow right'
        alt=''
        onClick={() => handleClick()}
      />
    </div>
  )
}

export default Blog
